export enum DelegatesView {
  MY_DELEGATIONS = 1,
  LIST = 2,
  DETAIL = 3,
  REFEREES = 4,
  REFEREE_DETAIL = 5,
  GROUPS = 6,
  GROUP_DETAIL = 7,
  EVALUATION = 8,
  REFEREE_EVALUATION = 9,
}
